// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'glasses-solid';

export const Component = () => (
  <path d='M24.563 13.823v2.922c0 1.389-.48 2.538-1.437 3.448-.958.958-2.107 1.437-3.496 1.437-1.34 0-2.49-.48-3.449-1.437-.958-.91-1.436-2.06-1.436-3.448 0-.432.047-.767.096-1.006l-4.12.048c.049.383.097.718.097.958 0 1.389-.479 2.538-1.437 3.496-.958.957-2.107 1.436-3.496 1.436-1.34 0-2.49-.479-3.448-1.436C1.479 19.283 1 18.134 1 16.745v-2.922c0-.047 0-.096.048-.143v-.144l5.89-10.297A.502.502 0 0 1 7.37 3c.335 0 .526.144.526.479 0 .048-.048.144-.096.287l-5.603 9.818c1.005-1.149 2.25-1.724 3.736-1.724.958 0 1.868.288 2.682.814.814.527 1.389 1.246 1.772 2.107h4.741a4.838 4.838 0 0 1 1.82-2.107c.814-.526 1.676-.814 2.682-.814 1.484 0 2.73.575 3.736 1.724l-5.604-9.818c-.047-.143-.096-.191-.096-.239 0-.335.192-.479.527-.479.144 0 .239.048.383.192l5.89 10.297c.048.143.096.239.096.287Z' />
);

export const viewBox = '0 0 25 25';
